import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../../../../store/root-reducer';
import AddProspectManuallyModal from './add-prospect-manually-modal';

const mapStateToProps = (state: RootState) => ({
  getFieldsRequestStatus: state.prospect.getFieldsRequest.status,
  addProspectManuallyRequestStatus:
    state.prospect.addProspectManuallyRequest.status,
  addProspectManuallyRequestMessage:
    state.prospect.addProspectManuallyRequest.message,
  addProspectManuallyRequestError:
    state.prospect.addProspectManuallyRequest.error,
  fields: state.prospect.fields,
});

const connector = connect(mapStateToProps);

export type IProps = ConnectedProps<typeof connector> & {
  onClose: () => void;
  show: boolean;
  t?: (x: string) => string;
  callId?: number;
  callerPhone?: string;
};

export default connector(AddProspectManuallyModal);
